import { useEffect, useMemo, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

import { APIMS } from "../../../../../../config/apims";
import { APISD } from "../../../../../../config/apisd";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";

import "bulma/css/bulma.css";
import "../../../../../../index.css";

export default function ModalUpdateEkskul(props) {
  const token = localStorage.getItem("token");

  const [branches, setBranches] = useState([]);
  const [loadingBranch, setLoadingBranch] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [form, setForm] = useState({
    ysb_branch_id: "",
    name_matpel: "",
    description: "",
  });

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  useEffect(() => {
    if (!props.show || !props.dataUpdate) return;

    setForm({
      ysb_branch_id: props.dataUpdate?.ysb_branch_id || "",
      name_matpel: props.dataUpdate?.name_matpel || "",
      description: props.dataUpdate?.description || "",
    });
  }, [props.dataUpdate, props.show]);

  useEffect(() => {
    let active = true;

    const fetchBranches = async () => {
      setLoadingBranch(true);

      try {
        const response = await APIMS.get(
          "/api/access/branches?page=1&limit=1000&ascending=1&search=",
          fetchParams
        );

        if (!active) return;

        setBranches(
          Array.isArray(response?.data?.data) ? response.data.data : []
        );
      } catch (error) {
        if (!active) return;
        setBranches([]);
        ToastError.fire({
          icon: "error",
          title: error?.response?.data?.message || "Gagal memuat data cabang",
        });
      } finally {
        if (active) setLoadingBranch(false);
      }
    };

    if (props.show) fetchBranches();

    return () => {
      active = false;
    };
  }, [fetchParams, props.show]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const extracurricularName = form.name_matpel.trim();
    const extracurricularDescription = form.description.trim();

    if (!props.id) {
      ToastError.fire({
        icon: "error",
        title: "ID ekstrakurikuler tidak ditemukan",
      });
      return;
    }

    if (!form.ysb_branch_id) {
      ToastError.fire({
        icon: "error",
        title: "Cabang wajib dipilih",
      });
      return;
    }

    if (!extracurricularName) {
      ToastError.fire({
        icon: "error",
        title: "Nama ekstrakurikuler wajib diisi",
      });
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await APISD.put(
        `/api/ekstrakurikuler/${props.id}`,
        {
          ysb_branch_id: form.ysb_branch_id,
          name_matpel: extracurricularName,
          description: extracurricularDescription,
        },
        fetchParams
      );

      if (response?.status === 200 || response?.status === 201) {
        ToastSuccess.fire({
          icon: "success",
          title:
            response?.data?.message ||
            "Ekstrakurikuler berhasil diperbarui",
        });

        props.GetResponseData?.();
        props.onHide?.();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal memperbarui data ekstrakurikuler",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="module-modal-dialog"
      contentClassName="module-modal-content"
    >
      <form onSubmit={handleSubmit}>
        <div className="module-modal-header">
          <div>
            <h5 className="module-modal-title">Update Ekstrakurikuler</h5>
            
          </div>

          <button
            type="button"
            className="module-modal-close"
            onClick={props.onHide}
            disabled={isSubmitting}
            aria-label="Tutup"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <Modal.Body className="module-modal-body mt-1 mx-2">
          <div className="module-form-grid">
            <div className="module-form-group module-form-span-2">
              <label
                className="module-form-label"
                htmlFor="update-ekskul-branch"
              >
                Cabang <span>*</span>
              </label>
              <select
                id="update-ekskul-branch"
                className="module-form-select"
                name="ysb_branch_id"
                value={form.ysb_branch_id}
                onChange={handleChange}
                disabled={loadingBranch || isSubmitting}
              >
                <option value="">
                  {loadingBranch ? "Memuat cabang..." : "Pilih Cabang"}
                </option>
                {branches.map((branch, index) => (
                  <option
                    key={branch?.branch_code || index}
                    value={branch?.branch_code || ""}
                  >
                    {branch?.branch_name || branch?.branch_code || "-"}
                  </option>
                ))}
              </select>
            </div>

            <div className="module-form-group module-form-span-2">
              <label
                className="module-form-label"
                htmlFor="update-ekskul-name"
              >
                Nama Ekstrakurikuler <span>*</span>
              </label>
              <input
                id="update-ekskul-name"
                type="text"
                className="module-form-input"
                name="name_matpel"
                value={form.name_matpel}
                onChange={handleChange}
                autoFocus
                disabled={isSubmitting}
                maxLength={150}
              />
            </div>

            <div className="module-form-group module-form-span-2">
              <label className="module-form-label" htmlFor="add-ekskul-description">
                Keterangan 
              </label>
              <textarea
                id="add-ekskul-description"
                type="text"
                className="predikat-form-control module-form-textarea"
                name="description"
                value={form.description}
                onChange={handleChange}
                // placeholder="Contoh: Cukup baik"
                required
              />
            </div>
          </div>
        </Modal.Body>

        <div className="module-modal-footer">
          <button
            type="button"
            className="module-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="module-modal-submit"
            disabled={isSubmitting || loadingBranch}
          >
            {isSubmitting && <span className="module-button-spinner" />}
            {isSubmitting ? "Memperbarui..." : "Perbarui"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
